export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_20.434e876b.jpg";